__webpack_require__.p = "https://static.spqr.app/519b2a21223bf71bd48783f6c85fc08f776b3f7f/_next/";